import type { VfConfig } from '#types/config/components/vf'
import type { RecursivePartial } from '#types/utils'

export default {
  brandClasses: {
    panel: {
      close: 'absolute top-0 right-0 m-4',
      footer: 'p-4 b-t b-grey-70 lg:px-6',
      header: 'p-4 b-b b-grey-70 lg:px-6',
      wrapper: 'p-4 lg:p-6'
    }
  },
  closeIconSize: 'md',
  ignoreSelectors: [
    '#nuanMessagingFrame',
    '#onetrust-banner-sdk',
    '.pac-container'
  ]
} satisfies RecursivePartial<VfConfig['dialog']>
